import Link from 'next/link';
import { RunProgressComponent } from './run-progress.component';
import { useRunChecklistStore } from '@/stores/run/run-checklist.store';
import { shallow } from 'zustand/shallow';
import { useEffect, useState } from 'react';
import { RunChecklistTree } from './run-by-id.component';

export default function RunBuilderMenuComponent({ title }: { title: string }) {
    const [runComplete, setRunComplete] = useState<boolean>(false);

    
    const [runChecklistTree, isPreview, isPublic, isBuilderPreview] =
    useRunChecklistStore(
      s => [
        s.runChecklistTree,
        s.isPreview,
        s.isPublic,
        s.isBuilderPreview
      ],
      shallow
    );

        
          useEffect(() => {
            const isCompleted = isRunChecklistFullyCompleted(
              runChecklistTree as RunChecklistTree
            );
            // console.log('isCompleted:', isCompleted);
            // console.log('runComplete:', runComplete);
        
            setRunComplete(isCompleted);
          }, [runChecklistTree?.checklist?.is_completed]);
      
            function isRunChecklistFullyCompleted(
              checklistTree: RunChecklistTree
            ): boolean {
              if (!checklistTree || !checklistTree?.children) {
                return false;
              }
              // console.log('checklistTree:', checklistTree);
          
              for (const child of checklistTree.children) {
                // If any task is not completed, return false
                if (!child.checklist.is_completed) {
                  return false;
                }
          
                // Recursively check child tasks
                if (!isRunChecklistFullyCompleted(child)) {
                  return false;
                }
              }
          
              // If all tasks are completed, return true
              return true;
            }

            
  return (
    <>
      <div className="border-b-[1px] border-solid border-black/10 cl_primary_background">
        {/* Run progress */}
        {/* <RunProgressComponent /> */}

        <div className="max-w-[1440px] mx-auto w-full h-full px-4 md:px-10">
          <div className="flex items-center justify-between gap-4 h-16 z-[1]">
            {/* Left side */}
            <div className="flex items-center gap-2">
              {/* Back */}
              <Link
                href={'/assigned'}
                className="flex items-center justify-center min-w-[40px] w-10 h-10 rounded-full bg-white border-[1px] border-solid border-black/20"
              >
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5649 0.43451C7.87732 0.746929 7.87732 1.25346 7.5649 1.56588L2.13059 7.0002L7.5649 12.4345C7.87732 12.7469 7.87732 13.2535 7.5649 13.5659C7.25248 13.8783 6.74595 13.8783 6.43353 13.5659L0.433533 7.56588C0.121114 7.25346 0.121114 6.74693 0.433533 6.43451L6.43353 0.43451C6.74595 0.12209 7.25248 0.12209 7.5649 0.43451Z"
                    fill="black"
                  />
                </svg>
              </Link>

              {/* Title */}
              <div className="text-lg font-semibold line-clamp-1">
                &nbsp;{title}
              </div>
              {!isPreview && !isBuilderPreview && !isPublic && runChecklistTree?.checklist?.workflow_configuration && (
                <div className="ml-0 text-gray-500 text-[12px] px-2 h-fit !items-start whitespace-nowrap rounded-xl border border-gray-400">
                  {runComplete ? 'Completed' : 'In-Progress'}
                </div>
              )}
            </div>

            {/* Right side */}
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
}
